export enum SearchBarMessages {
  Placeholder = 'Search...',
}
